module.exports = __webpack_public_path__ + "img/06.eaee8d60.jpg";